<template>
  <div>
    <h1>{{ $t('zoneSettings') }}</h1>
    <div v-for="(item, index) in program" :key="index" style="display: flex; margin: 10px 0">
      <div style="width: 200px">
        <el-select v-model="item.zone" :placeholder="$t('pleaseChoose')" style="width: 80px">
          <el-option
            v-for="item in zoneOrGroup"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        (<el-input style="width: 80px" v-model="item.zoneNo" @change.native="zoneChange(item)" />) = 
      </div>
      <div style="width: calc(100% - 300px);">
        (
          <div style="display: inline-block;" :style="{width:_index === 0 ? '400px' : '440px'}" v-for="(_item, _index) in item.rightItem" :key="index + '_' + _index">
            <div v-if="_index > 0" style="display: inline-block; width: 40px; text-align: center;">,</div>
            <el-input style="width: 80px" @change.native="panelChange(_item)" v-model="_item.panelNo" />-
            <el-input style="width: 80px" @change.native="loopChange(_item)" v-model="_item.loopNo" />-
            <el-input style="width: 80px" @change.native="addressChange(_item)" v-model="_item.addressNo" />~
            <el-input style="width: 80px" @change.native="addressEndChange(_item)" v-model="_item.addressEndNo" />
            <el-button class="gray-btn" style="width: 40px; margin-left: 10px" v-if="item.rightItem.length > 1" @click="delSubItem(index, _index)">-</el-button>
          </div>
          <el-button class="blue-btn" style="width: 40px; margin-left: 10px" @click="addSubItem(index)">+</el-button>
        )
        <el-button class="gray-btn" style="width: 40px;" @click="delItem(index)">-</el-button>
        <el-button class="blue-btn" @click="saveProgram(index)">{{ $t('save') }}</el-button>
      </div>
    </div>
    <el-button class="blue-btn" style="width: 40px;" @click="addItem">+</el-button>
  </div>
</template>

<script>
import { getZGInfo, operateZGInfo, deleteZGInfo } from '../../api/zoneSetting'

export default {
  name: 'zoneSettings',
  data () {
    return {
      zoneOrGroup: [{
        name: 'Z',
        value: 'Z'
      }, {
        name: 'G',
        value: 'G'
      }],
      program: [{
        zone: 'Z',
        zoneNo: 1,
        rightItem: [{
          panelNo: 0,
          loopNo: 1,
          addressNo: 1,
          addressEndNo: ''
        }]
      }],
      panelNo: this.$route.query.panelNo,
      projectId: this.$route.query.projectId
    }
  },
  mounted () {
    this.getZGInfo()
  },
  methods: {
    addSubItem (index) {
      this.program[index].rightItem.push({
        panelNo: 0,
        loopNo: 1,
        addressNo: 1,
        addressEndNo: ''
      })
    },
    delSubItem (index, _index) {
      this.program[index].rightItem.splice(_index, 1)
      this.saveProgram(index)
      // deleteZGInfo({
      //   projectId: this.projectId,
      //   type: this.program[index].zone,
      //   value: +this.program[index].zoneNo,
      //   panelNo: +this.program[index].rightItem[_index].panelNo
      // }).then(res => {
      //   this.$message.success(res.message)
      //   this.getZGInfo()
      // })
    },
    addItem () {
      this.program.push({
        zone: 'Z',
        zoneNo: 1,
        rightItem: [{
          panelNo: 0,
          loopNo: 1,
          addressNo: 1,
          addressEndNo: ''
        }]
      })
    },
    delItem (index) {
      deleteZGInfo({
        projectId: this.projectId,
        panelNo: this.panelNo,
        type: this.program[index].zone,
        value: +this.program[index].zoneNo
      }).then(res => {
        this.$message.success(this.$t('deleteSuccess'))
        this.getZGInfo()
      })
    },
    saveProgram (index) {
      let code = `${this.program[index].zone}(${this.program[index].zoneNo})=(`
      const strArr = this.program[index].rightItem.map(m => {
        return `${m.panelNo}-${m.loopNo}-${m.addressNo}${m.addressEndNo ? '~' + m.addressEndNo : ''}`
      })
      code += strArr.join(',') +')'
      const params = {
        projectId: this.projectId,
        panelNo: this.panelNo, // 控制器号，是传入的，非输入的
        listData: [code]
      }
      operateZGInfo(params).then(res => {
        this.$message.success(this.$t('saveSuccess'))
        this.getZGInfo()
      }).catch(() => {
        this.getZGInfo()
      })
    },
    getZGInfo () {
      getZGInfo({
        projectId: this.projectId
      }).then(res => {
        if (res.data) {
          this.program = res.data.map(n => {
            return this.handleStr(n)
          })
        }
      })
    },
    handleStr (str) {
      const strArr = str.split('=(')
      const obj = {rightItem: []}
      obj.zone = strArr[0].substr(0,1)
      obj.zoneNo = strArr[0].substr(2, strArr[0].length -3)
      const right = strArr[1].split(')')[0]
      right.split(',').map(n => {
        const _obj = {}
        const item = n.split('-')
        if (item.length > 2) {
          _obj.panelNo = item[0]
          _obj.loopNo = item[1]
          if (item[2].indexOf('~') > -1) {
            obj.right_obj.addressNo = item[2].split('~')[0]
            _obj.addressEndNo = item[2].split('~')[1]
          } else {
            _obj.addressNo = item[2]
          }
        } else {
          _obj.panelNo = 0
          _obj.loopNo = item[0]
          if (item[1].indexOf('~') > -1) {
            _obj.addressNo = item[1].split('~')[0]
            _obj.addressEndNo = item[1].split('~')[1]
          } else {
            _obj.addressNo = item[1]
          }
        }
        obj.rightItem.push(_obj)
      })
      return obj
    },
    zoneChange (data) {
      const value = +data.zoneNo
      if (value < 1 || value > 998 || isNaN(value)) {
        this.$message.error(this.$t('outOfRange'))
        data.zoneNo = 1
      }
    },
    panelChange (data) {
      const value = +data.panelNo
      if (value < 0 || value > 99 || isNaN(value)) {
        this.$message.error(this.$t('outOfRange'))
        data.panelNo = 1
      }
    },
    loopChange (data) {
      const value = +data.loopNo
      if (value < 1 || value > 2 || isNaN(value)) {
        this.$message.error(this.$t('outOfRange'))
        data.loopNo = 1
      }
    },
    addressChange (data) {
      const value = +data.addressNo
      if (value < 1 || value > 200 || isNaN(value)) {
        this.$message.error(this.$t('outOfRange'))
        data.addressNo = 1
      }
    },
    addressEndChange (data) {
      if (data.addressEndNo) {
        const value = +data.addressEndNo
        if (value < 1 || value > 200 || isNaN(value)) {
          this.$message.error(this.$t('outOfRange'))
          data.addressEndNo = ''
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
h1 {
  font-size: 24px;
  font-weight: 400;
}
</style>
